import React from "react";
import { connect } from "react-redux";
import FFRRetry from "./FfrRetry";


class FfrRetryTable extends React.Component {

    render() {
        return (
            <div>
                <FFRRetry
                    loggedInUser={this.props.loggedInUser}
                    dcValue={this.props.dcValue}
                ></FFRRetry>
            </div>
        );
    }
}

export default connect()(FfrRetryTable);

export { FfrRetryTable };